import {
  ADD_FAVOURITE,
  FETCH_ALL_CONTACT,
  FETCH_ALL_CONTACT_SUCCESS,
  FILTER_CONTACT,
  GET_ALL_CONTACT,
  GET_UNSELECTED_ALL_CONTACT,
  HANDLE_REQUEST_CLOSE,
  HIDE_CONTACT_LOADER,
  ON_ADD_CONTACT,
  ON_ALL_CONTACT_SELECT,
  ON_CONTACT_CLOSE,
  ON_CONTACT_SELECT,
  ON_DELETE_CONTACT,
  ON_DELETE_SELECTED_CONTACT,
  ON_FILTER_OPTION_SELECT,
  ON_SAVE_CONTACT,
  ON_TOGGLE_DRAWER,
  SHOW_MESSAGE,
  UPDATE_SEARCH_USER,
  GET_EMPLOYEE_WORKING_HOURS,
  SET_EMPLOYEE_WORKING_HOURS,
  SET_EMPLOYEE_WORKING_HOURS_DATE,
  SET_EMPLOYEE_WORKING_HOURS_FROM,
  SET_EMPLOYEE_WORKING_HOURS_TO,
  SET_EMPLOYEE_WORKING_HOURS_COMMENT,
  SUBMIT_WORKING_HOURS_FORM,
  CHANGE_ADMIN_EMPLOYEE_DISPLAY,
  WORKING_HOURS_UPDATE,
  GET_ALL_SERVICES_BY_BUSINESS,
  SET_ALL_SERVICES_BY_BUSINESS,
  GET_IMAGE_FILE,
  SET_IMAGE_FILE,
  GET_SERVICE_TABLE_SERVICES,
  SET_SERVICE_TABLE_SERVICES,
  SUBMIT_ALL_VALUES_EMPLOYEE,
  SUBMIT_ALL_VALUES_EMPLOYEE_RESPONSE,
  FILL_ADMIN_EMPLOYEE_SELECTED_DETAILS,
  SUBMIT_EDIT_EMPLOYEE_DETAILS,
  SUBMIT_EDIT_EMPLOYEE_DETAILS_RESPONSE,
  CHANGE_ADD_EMPLOYEE_STATE,
  CHANGE_EDIT_EMPLOYEE_STATE,
  CLEAR_FORM_DATA,
  SELECTED_EMPLOYEE_DELETE,
  SELECTED_EMPLOYEE_DELETE_RESPONSE,
  CHANGE_ADD_WORKING_HOURS_STATE,
  CHANGE_EDIT_WORKING_HOURS_STATE,
  DELETE_SELECTED_WORKING_HOURS,
  DELETE_SELECTED_WORKING_HOURS_RESPONSE,
  EDIT_WORKING_HOURS_RESPONSE,
  EMPLOYEE_FAIL_RESPONSE,
  EMPLOYEE_ON_HIDE_LOADER,
  EMPLOYEE_ON_SHOW_LOADER,
  EMPLOYEE_DELETE_WORKING_HOURS_MODAL_TOGGLE,
  EMPLOYEE_DONT_DELETE_WORKING_HOURS,
  EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY,
  EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY_RESPONSE,
  EMPLOYEE_DELETE_WORKING_HOURS_FORCEFULLY,
  EMPLOYEE_DELETE_WORKING_HOURS_FORCEFULLY_RESPONSE,
  EMPLOYEE_OUT_OF_BUSINESS_HOURS_ADD,
  EMPLOYEE_EDIT_WORKING_HOURS_FORCEFULLY_RESPONSE,
  BULK_EMPLOYEE_CLOSE_WORKING_HOURS,
  BULK_EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY,
  BULK_EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY_RESPONSE,
  EMPLOYEE_WORKING_HOURS_SHOW_LOADER,
  EMPLOYEE_WORKING_HOURS_HIDE_LOADER,
  EMPLOYEE_WORKING_HOURS_CLEAR_TABLE,
  EMPLOYEE_WORKING_HOURS_NEW_REQUEST_CLOSE,
  EMPLOYEE_BUSINESS_CLOSURE_CANCEL,
  EMPLOYEE_BUSINESS_CLOSURE_DAY,
  EMPLOYEE_BUSINESS_CLOSURE_DAY_ERROR_ADD,
  EMPLOYEE_BUSINESS_CLOSURE_DAY_ERROR_REMOVE,
  EMPLOYEE_BUSINESS_CLOSURE_FROM,
  EMPLOYEE_BUSINESS_CLOSURE_TO,
  EMPLOYEE_BUSINESS_CLOSURE_SUBMIT,
  EMPLOYEE_BUSINESS_CLOSURE_SUBMIT_RESPONSE,
  EMPLOYEE_BUSINESS_CLOSURE_OPERATIONS_SET,
  EMPLOYEE_BUSINESS_CLOSURE_SCHEDULE_SET,
  EMPLOYEE_BUSINESS_WORKING_HOURS_SUBMIT,
  EMPLOYEE_BUSINESS_WORKING_HOURS_SUBMIT_RESPONSE,
  EMPLOYEE_BUSINESS_WORKING_HOURS_ADD_FORCEFULLY,
  EMPLOYEE_BUSINESS_WORKING_HOURS_ADD_FORCEFULLY2,
  EMPLOYEE_BUSINESS_WORKING_HOURS_ADD_FORCEFULLY_RESPONSE,
  EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_FORCEFULLY,
  EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_FORCEFULLY_RESPONSE,
  EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_FORCEFULLY,
  EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_FORCEFULLY_RESPONSE,
  BUSINESS_EXCEPTION_BASED_AVAILIABLITY,
  EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_SUBMIT,
  EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_SUBMIT_RESPONSE,
  EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_SUBMIT_RESPONSE,
  EMPLOYEE_BUSINESS_WORKING_HOURS_HAVE_APPOINTMENT,
  EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_APPOINTMENT,
  EMPLOYEE_BUSINESS_HANDLE_REQUEST_CLOSE,
  GET_ALL_SERVICES_BY_BUSINESS_SUPER_ADMIN,
  GET_EMPLOYEE_PLAN,
  GET_EMPLOYEE_PLAN_SUCCESS,
  REMOVE_EMPLOYEE_IMAGE
} from "../constants/ActionTypes";

export const fetchContacts = payload => ({
  type: FETCH_ALL_CONTACT,
  payload,
});

export const fetchContactsSuccess = contact => ({
  type: FETCH_ALL_CONTACT_SUCCESS,
  payload: contact,
});
export const showContactMessage = message => ({
  type: SHOW_MESSAGE,
  payload: message,
});
export const addFavourite = data => ({
  type: ADD_FAVOURITE,
  payload: data,
});
export const onContactSelect = data => ({
  type: ON_CONTACT_SELECT,
  payload: data,
});

export const onAddContact = () => ({
  type: ON_ADD_CONTACT,
  payload: "",
});
export const onContactClose = () => ({
  type: ON_CONTACT_CLOSE,
  payload: "",
});
export const onFilterOptionSelect = option => ({
  type: ON_FILTER_OPTION_SELECT,
  payload: option,
});
export const onSaveContact = data => ({
  type: ON_SAVE_CONTACT,
  payload: data,
});
export const onDeleteContact = data => ({
  type: ON_DELETE_CONTACT,
  payload: data,
});
export const onDeleteSelectedContact = () => ({
  type: ON_DELETE_SELECTED_CONTACT,
  payload: "",
});
export const filterContact = userName => ({
  type: FILTER_CONTACT,
  payload: userName,
});
export const getAllContact = () => ({
  type: GET_ALL_CONTACT,
  payload: "",
});
export const getUnselectedAllContact = () => ({
  type: GET_UNSELECTED_ALL_CONTACT,
  payload: "",
});
export const onAllContactSelect = () => ({
  type: ON_ALL_CONTACT_SELECT,
  payload: "",
});
export const updateContactUser = userName => ({
  type: UPDATE_SEARCH_USER,
  payload: userName,
});
export const onToggleDrawer = () => ({
  type: ON_TOGGLE_DRAWER,
});
export const handleRequestClose = () => ({
  type: HANDLE_REQUEST_CLOSE,
});
export const hideContactLoader = () => ({
  type: HIDE_CONTACT_LOADER,
});

export const saveEmployee = payload => ({
  type: ON_SAVE_CONTACT_STATE,
  payload,
});

export const getEmployeeWorkingHours = payload => ({
  type: GET_EMPLOYEE_WORKING_HOURS,
  payload,
});
export const setEmployeeWorkingHours = payload => ({
  type: SET_EMPLOYEE_WORKING_HOURS,
  payload,
});

export const setEmployeeWorkingHoursDate = payload => ({
  type: SET_EMPLOYEE_WORKING_HOURS_DATE,
  payload,
});

export const setEmployeeWorkingHoursFrom = payload => ({
  type: SET_EMPLOYEE_WORKING_HOURS_FROM,
  payload,
});

export const setEmployeeWorkingHoursTo = payload => ({
  type: SET_EMPLOYEE_WORKING_HOURS_TO,
  payload,
});

export const setEmployeeWorkingHoursComment = payload => ({
  type: SET_EMPLOYEE_WORKING_HOURS_COMMENT,
  payload,
});

export const submitWorkingHoursForm = payload => ({
  type: SUBMIT_WORKING_HOURS_FORM,
  payload,
});

export const changeAdminEmployeeDisplay = payload => ({
  type: CHANGE_ADMIN_EMPLOYEE_DISPLAY,
  payload,
});
export const workingHoursUpdate = payload => ({
  type: WORKING_HOURS_UPDATE,
  payload,
});

export const getServicesByBusiness = payload => ({
  type: GET_ALL_SERVICES_BY_BUSINESS,
  payload,
});

export const getServicesByBusinessSuperAdmin = payload => ({
  type: GET_ALL_SERVICES_BY_BUSINESS_SUPER_ADMIN,
  payload,
});

export const setServicesByBusiness = payload => ({
  type: SET_ALL_SERVICES_BY_BUSINESS,
  payload,
});

export const setImageFile = payload => ({
  type: SET_IMAGE_FILE,
  payload,
});

export const getImageFile = payload => ({
  type: GET_IMAGE_FILE,
  payload,
});

export const getServiceTableServices = payload => ({
  type: GET_SERVICE_TABLE_SERVICES,
  payload,
});
export const setServiceTableServices = payload => ({
  type: SET_SERVICE_TABLE_SERVICES,
  payload,
});

export const submitAllValuesEmployee = payload => ({
  type: SUBMIT_ALL_VALUES_EMPLOYEE,
  payload,
});

export const submitAllValuesEmployeeResponse = payload => ({
  type: SUBMIT_ALL_VALUES_EMPLOYEE_RESPONSE,
  payload,
});

export const fillAdminEmployeeSelectedDetails = payload => ({
  type: FILL_ADMIN_EMPLOYEE_SELECTED_DETAILS,
  payload,
});
 export const removeEmployeeImage = () => ({
   type:REMOVE_EMPLOYEE_IMAGE
 })
export const submitEditEmployeeDetails = payload => ({
  type: SUBMIT_EDIT_EMPLOYEE_DETAILS,
  payload,
});

export const submitEditEmployeeDetailsResponse = payload => ({
  type: SUBMIT_EDIT_EMPLOYEE_DETAILS_RESPONSE,
  payload,
});

export const changeAddEmployeeState = payload => ({
  type: CHANGE_ADD_EMPLOYEE_STATE,
  payload,
});

export const changeEditEmployeeState = payload => ({
  type: CHANGE_EDIT_EMPLOYEE_STATE,
  payload,
});

export const clearFormData = () => ({
  type: CLEAR_FORM_DATA,
});

export const selectedEmployeeDelete = payload => ({
  type: SELECTED_EMPLOYEE_DELETE,
  payload,
});

export const selectedEmployeeDeleteResposne = () => ({
  type: SELECTED_EMPLOYEE_DELETE_RESPONSE,
});

export const changeEditWorkingHoursState = payload => ({
  type: CHANGE_EDIT_WORKING_HOURS_STATE,
  payload,
});

export const changeAddWorkingHoursState = payload => ({
  type: CHANGE_ADD_WORKING_HOURS_STATE,
  payload,
});

export const deleteSelectedWorkingHours = payload => ({
  type: DELETE_SELECTED_WORKING_HOURS,
  payload,
});

export const deleteSelectedWorkingHoursResponse = payload => ({
  type: DELETE_SELECTED_WORKING_HOURS_RESPONSE,
  payload,
});

export const editWorkingHoursResponse = payload => ({
  type: EDIT_WORKING_HOURS_RESPONSE,
  payload,
});

export const employeeFailResponse = payload => ({
  type: EMPLOYEE_FAIL_RESPONSE,
  payload,
});

export const employeeOnHideLoader = payload => ({
  type: EMPLOYEE_ON_HIDE_LOADER,
  payload,
});

export const employeeOnShowLoader = payload => ({
  type: EMPLOYEE_ON_SHOW_LOADER,
  payload,
});

export const employeeToggleModal = payload => ({
  type: EMPLOYEE_DELETE_WORKING_HOURS_MODAL_TOGGLE,
  payload,
});

export const employeeOutOfBusinessHoursAdd = payload => ({
  type: EMPLOYEE_OUT_OF_BUSINESS_HOURS_ADD,
  payload,
});

export const employeeAddWorkingHoursForcefully = payload => ({
  type: EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY,
  payload,
});

export const employeeAddWorkingHoursForcefullyResponse = payload => ({
  type: EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY_RESPONSE,
  payload,
});

export const employeeEditWorkingHoursForcefullyResponse = payload => ({
  type: EMPLOYEE_EDIT_WORKING_HOURS_FORCEFULLY_RESPONSE,
  payload,
});

export const employeeDeleteWorkingHoursForcefully = payload => ({
  type: EMPLOYEE_DELETE_WORKING_HOURS_FORCEFULLY,
  payload,
});

export const employeeDeleteWorkingHoursForcefullyResponse = payload => ({
  type: EMPLOYEE_DELETE_WORKING_HOURS_FORCEFULLY_RESPONSE,
  payload,
});

export const employeeDontDeleteWorkingHours = payload => ({
  type: EMPLOYEE_DONT_DELETE_WORKING_HOURS,
  payload,
});

export const bulkEmployeeCloseWorkingHours = payload => ({
  type: BULK_EMPLOYEE_CLOSE_WORKING_HOURS,
  payload,
});

export const bulkEmployeeAddWorkingHoursForcefully = payload => ({
  type: BULK_EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY,
  payload,
});

export const bulkEmployeeAddWorkingHoursForcefullyResponse = payload => ({
  type: BULK_EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY_RESPONSE,
  payload,
});

export const employeeWorkingHoursShowLoader = payload => ({
  type: EMPLOYEE_WORKING_HOURS_SHOW_LOADER,
  payload,
});

export const employeeWorkingHoursHideLoader = payload => ({
  type: EMPLOYEE_WORKING_HOURS_HIDE_LOADER,
  payload,
});

export const employeeWorkingHoursClearTable = payload => ({
  type: EMPLOYEE_WORKING_HOURS_CLEAR_TABLE,
  payload,
});

export const employeeWorkingHoursNewRequestClose = payload => ({
  type: EMPLOYEE_WORKING_HOURS_NEW_REQUEST_CLOSE,
  payload,
});

export const employeeBusinessClosureDay = payload => ({
  type: EMPLOYEE_BUSINESS_CLOSURE_DAY,
  payload,
});

export const employeeBusinessClosureFrom = payload => ({
  type: EMPLOYEE_BUSINESS_CLOSURE_FROM,
  payload,
});

export const employeeBusinessClosureTo = payload => ({
  type: EMPLOYEE_BUSINESS_CLOSURE_TO,
  payload,
});

export const employeeBusinessClosureDayErrorAdd = payload => ({
  type: EMPLOYEE_BUSINESS_CLOSURE_DAY_ERROR_ADD,
  payload,
});

export const employeeBusinessClosureDayErrorRemove = payload => ({
  type: EMPLOYEE_BUSINESS_CLOSURE_DAY_ERROR_REMOVE,
  payload,
});

export const employeeBusinessClosureCancel = payload => ({
  type: EMPLOYEE_BUSINESS_CLOSURE_CANCEL,
  payload,
});

export const employeeBusinessClosureSubmit = payload => ({
  type: EMPLOYEE_BUSINESS_CLOSURE_SUBMIT,
  payload,
});

export const employeeBusinessClosureSubmitResponse = payload => ({
  type: EMPLOYEE_BUSINESS_CLOSURE_SUBMIT_RESPONSE,
  payload,
});

export const employeeBusinessClosureOperationsAdd = payload => ({
  type: EMPLOYEE_BUSINESS_CLOSURE_OPERATIONS_SET,
  payload,
});

export const employeeBusinessClosureScheduleSet = payload => ({
  type: EMPLOYEE_BUSINESS_CLOSURE_SCHEDULE_SET,
  payload,
});

export const employeeBusinessWorkingHoursSubmit = payload => ({
  type: EMPLOYEE_BUSINESS_WORKING_HOURS_SUBMIT,
  payload,
});

export const employeeBusinessWorkingHoursSubmitResponse = payload => ({
  type: EMPLOYEE_BUSINESS_WORKING_HOURS_SUBMIT_RESPONSE,
  payload,
});

export const employeeBusinessWorkingHoursAddForcefully = payload => ({
  type: EMPLOYEE_BUSINESS_WORKING_HOURS_ADD_FORCEFULLY,
  payload,
});

export const employeeBusinessWorkingHoursAddForcefullyResponse = payload => ({
  type: EMPLOYEE_BUSINESS_WORKING_HOURS_ADD_FORCEFULLY_RESPONSE,
  payload,
});

export const employeeBusinessWorkingHoursEditForcefully = payload => ({
  type: EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_FORCEFULLY,
  payload,
});

export const employeeBusinessWorkingHoursEditForcefullyResponse = payload => ({
  type: EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_FORCEFULLY_RESPONSE,
  payload,
});

export const employeeBusinessWorkingHoursDeleteForcefully = payload => ({
  type: EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_FORCEFULLY,
  payload,
});

export const employeeBusinessWorkingHoursDeleteForcefullyResponse = payload => ({
  type: EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_FORCEFULLY_RESPONSE,
  payload,
});

export const businessExceptionBasedAvailiablity = payload => ({
  type: BUSINESS_EXCEPTION_BASED_AVAILIABLITY,
  payload,
});

export const employeeBusinessWorkingHoursDeleteSubmit = payload => ({
  type: EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_SUBMIT,
  payload,
});

export const employeeBusinessWorkingHoursDeleteSubmitResponse = payload => ({
  type: EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_SUBMIT_RESPONSE,
  payload,
});

export const employeeBusinessWorkingHoursEditSubmitResponse = payload => ({
  type: EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_SUBMIT_RESPONSE,
  payload,
});

export const employeeBusinessWorkingHoursHaveAppointment = payload => ({
  type: EMPLOYEE_BUSINESS_WORKING_HOURS_HAVE_APPOINTMENT,
  payload,
});

export const employeeBusinessWorkingHoursDeleteAppointment = payload => ({
  type: EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_APPOINTMENT,
  payload,
});

export const employeeBusinessHandleRequestClose = payload => ({
  type: EMPLOYEE_BUSINESS_HANDLE_REQUEST_CLOSE,
  payload,
});

export const getEmployeePlan = payload => ({
  type: GET_EMPLOYEE_PLAN,
  payload
});

export const getEmployeePlanSuccess = payload => ({
  type: GET_EMPLOYEE_PLAN_SUCCESS,
  payload
});



// WEBPACK FOOTER //
// ./actions/EmployeeAction.js